module.exports = __webpack_public_path__ + "img/logo.31f49159.png";